import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import toast, { Toaster } from "react-hot-toast";

// Import local product images
import flex from "../assets/product/active_flex.png";
import leaf from "../assets/product/leaf.png";
import postpartum from "../assets/product/postpartum.png";
import disposable from "../assets/product/disposable.png";


const Products = () => {
  const products = [
    { 
      id: 1, 
      name: "EVEYA Active Flex", 
      desc: "Feel Fresh. Stay Confident. All Day Protection.",
      oldPrice: "22.00",
      price: "22.00", 
      image: flex 
    },
       { 
      id: 2, 
      name: "Leaf Pads", 
      desc: "Regular usage pads High Performance",
      oldPrice: "15.00",
      price: "15.00", 
      image: leaf 
    },
    { 
      id: 3, 
      name: "Eveya Disposable Panties", 
      desc: "Soft, Secure & All-Day Leak Protection for Normal Flow",
      oldPrice: "60.00",
      price: "60.00", 
      image: disposable 
    },
    { 
      id: 3, 
      name: "Eveya Post Partum Pads", 
      desc: "Extra Long Protection with Super Absorbent Core",
      oldPrice: "55.00",
      price: "55.00", 
      image: postpartum 
    },
 
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF5F6] p-6 pb-20 font-sans">
      <Toaster position="bottom-right" />
      
      {/* Header Section */}
      <div className="text-center mb-10 pt-10">
        <h1 className="text-4xl md:text-5xl font-black text-[#4A0404] tracking-tight mb-2">
          YOUR CARE COLLECTION
        </h1>
        <p className="text-[#B17F8D] font-bold uppercase text-[10px] tracking-[0.3em]">
          Comfort delivered to your doorstep
        </p>
      </div>

      {/* Search and Sort Bar */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 mb-12 px-4">
        <div className="relative w-full max-w-sm">
          <input 
            type="text" 
            placeholder="Search products..." 
            className="w-full px-6 py-3 rounded-2xl border border-rose-100 focus:outline-none focus:ring-2 focus:ring-rose-200 bg-white/80 placeholder:text-gray-400 text-sm"
          />
        </div>
        <div className="relative w-full md:w-auto">
          <select className="w-full md:w-56 px-4 py-3 rounded-2xl border border-rose-100 focus:outline-none bg-white text-sm text-gray-700 appearance-none cursor-pointer">
            <option>Sort by: Featured</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
            ▼
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 px-4">
        {products.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
      {/* <div>
        <ProductFaqs />
      </div> */}
    </div>
  );
};

const ProductCard = ({ product }) => {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="bg-white rounded-[2rem] p-5 shadow-[0_10px_30px_rgba(0,0,0,0.03)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-all duration-300 flex flex-col h-full cursor-pointer"
    >
      {/* Product Image */}
      <div className="bg-[#F9F9F9] rounded-2xl overflow-hidden aspect-square mb-6 flex items-center justify-center">
        <img 
          src={product.image} 
          alt={product.name} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
      </div>

      {/* Product Details */}
      <div className="flex flex-col flex-grow">
        <h2 className="text-[1.1rem] font-black text-[#4A0404] leading-tight mb-2">
          {product.name}
        </h2>
        
        <p className="text-[#FF7B9C] text-[0.75rem] font-semibold leading-relaxed mb-4 flex-grow">
          {product.desc}
        </p>

        {/* Price Section */}
        <div className="mt-auto">
          <p className="text-[#FFB5C7] text-[10px] font-black uppercase tracking-wider mb-1">
            Price
          </p>
          <div className="flex items-center gap-2">
            <span className="text-gray-400 line-through text-lg font-bold">
              ₹{product.oldPrice}
            </span>
            <span className="text-[#4A0404] text-xl font-black">
              ₹{product.price}
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Products;